export enum CargoCompanyAddRequestContractMaintenancePolicy {
  BASIC = "BASIC",
  AUCTION = "AUCTION",
}

export type CargoCompanyAddRequestBody = {
  taxId: string;
  regon: string | null;
  krsNo: string | null;
  companyName: string;
  displayName: string;
  headquartersAddressString: string;
  contractMaintenancePolicy: CargoCompanyAddRequestContractMaintenancePolicy;
  notes: string;
};

type CargoCompanyAddRequest = {
  taxId: string;
  regon: string | null;
  krsNo: string | null;
  companyName: string;
  displayName: string;
  headquartersAddressString: string;
  contractMaintenancePolicy: CargoCompanyAddRequestContractMaintenancePolicy;
  notes: string;
};

export default CargoCompanyAddRequest;
